import React from 'react';
import TrashCan from '@uber/base-icons/trash-can';
import { useStyletron } from 'baseui';
import { ICON_SIZE } from '../../constants';
import type { ActionButtonPropsT } from '../../types';
import { ActionButton } from '../action-button';
type PropsT = Omit<ActionButtonPropsT, 'onClick'> & {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
};
export function DeleteButton({
  onClick
}: PropsT) {
  const [, theme] = useStyletron();
  return <ActionButton icon={<TrashCan size={ICON_SIZE} color={theme.colors.contentPrimary} />} name="Delete Annotation" onClick={onClick} tooltipContent="Delete Annotation" />;
}